export default "__VITE_ASSET__9266d19b__"